import React from 'react';
import Icons from 'assets/icons';

interface CircularProgressProps {
  progress?: number;
}

const CircularProgress = ({
  progress = 0,
}: CircularProgressProps): React.JSX.Element => {
  const size = 22;
  const strokeWidth = 4;
  const radius = (size - strokeWidth) / 2;
  const center = size / 2;
  const circumference = 2 * Math.PI * radius;
  const rotationTransform = `rotate(-90 ${center} ${center})`;

  const isComplete = progress === 100;

  const strokeDashoffset = isComplete
    ? 0
    : circumference - (progress / 100) * circumference;

  return (
    <div
      className="w-6 h-6 relative flex justify-center items-center"
      role="img"
      aria-label={isComplete ? 'Completed' : `${progress}% complete`}
      data-testid="circular-progress"
    >
      <svg
        width={size}
        height={size}
        className="w-full h-full"
        aria-hidden="true"
      >
        {isComplete ? (
          <circle
            className="text-navy-800"
            strokeWidth={strokeWidth}
            strokeDasharray="0"
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            stroke="currentColor"
            fill="currentColor"
            r={radius}
            cx={center}
            cy={center}
          />
        ) : (
          <>
            <circle
              className="text-navy-300"
              strokeWidth={strokeWidth}
              stroke="currentColor"
              fill="transparent"
              r={radius}
              cx={center}
              cy={center}
              transform={rotationTransform}
            />
            <circle
              className="text-navy-800"
              strokeWidth={strokeWidth}
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              stroke="currentColor"
              fill="transparent"
              r={radius}
              cx={center}
              cy={center}
              transform={rotationTransform}
            />
          </>
        )}
      </svg>
      {isComplete && (
        <div className="absolute top-[5px]">
          <Icons.CheckOld className="text-white h-3 w-3" aria-hidden="true" />
        </div>
      )}
    </div>
  );
};

export default CircularProgress;
